import {ActiveOrderState} from '../../models';
import {makeReducer} from '../../redux-toolbelt';

import {setUserReportOrderDetails} from './userReportOrderDetailsActions';

export default makeReducer<ActiveOrderState, ActiveOrderState>(setUserReportOrderDetails, {
  defaultState: {},
});
